import { useMemo } from 'react'
import { FieldHookConfig, useField as useFormikField, useFormikContext } from 'formik'

export function useField<Val = any>(fieldConfig: string | FieldHookConfig<Val>) {
  const [field, meta] = useFormikField<Val>(fieldConfig)
  const { setFieldValue, setFieldTouched, setFieldError } = useFormikContext()

  const helpers = useMemo(
    () => ({
      setValue: (value: Val, shouldValidate?: boolean) => setFieldValue(field.name, value, shouldValidate),
      setTouched: (value: boolean, shouldValidate?: boolean) => setFieldTouched(field.name, value, shouldValidate),
      setError: (value?: string) => setFieldError(field.name, value)
    }),
    [setFieldTouched, setFieldValue, setFieldError, field.name]
  )

  return [field, meta, helpers] as const
}